module.exports = __webpack_public_path__ + "img/illust-01.87f628d0.png";